// Who the console speaks for, and where an issue was published. Both come
// from the API (/v1/catalog and the manifest), never from the bundle.

export function producerName(catalog) {
  return catalog?.producer?.name || "Forecaster console";
}

export function pageTitle(catalog) {
  return `${producerName(catalog)} · forecaster console`;
}

/** s3://bucket/prefix/grib/<issue>/ for a published issue, else null. */
export function publishedAt(manifest) {
  const p = manifest?.publish;
  if (!p) return null;
  return `s3://${p.bucket}/${p.prefix || ""}grib/${manifest.issue_id}/`;
}

/** One line for the Issue panel about where issues go. */
export function publishTarget(catalog) {
  const p = catalog?.publish;
  return p?.enabled ? `Each issue is uploaded to s3://${p.bucket}/${p.prefix || ""}` : "Publishing is off: issues stay in this console.";
}

export function zipName(manifest) {
  return `${manifest?.producer?.slug || "issue"}-${manifest.issue_id}.zip`;
}
